<template>
    <div class="Index">
        <img v-lazy="'../../static/img/banner3.png'" style="width:100%" alt="">
        <h2 class="h2bottom" style="margin-top:3vw">关于我们</h2>
        <p style="font-size:1.5vw;font-weight: 400;color: #666666;margin-bottom:5vw">—— CORPORATE CULTURE ——</p>
        <div class="divText">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中运卡行网络营销，是中运卡行集团旗下的数字营销平台，拥有中运卡行APP司机版、货主版、PC平台等各大数字资产的应用场景，通过高品质内容生产和多形态、多端口分发，产生高质量流量并进行有影响力的数字营销，为货车行业广告主提供货车司机、货主定向传播运营解决方案。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在新闻和内容打造上，中运卡行坚持对品质的极致追求。目前，中运卡行APP在金融、货车、ETC、加油、车险、货车后服务市场多产品线。司机入驻数量已有约34万货主司机、超过3.2万货主，日均曝光达15万货车司机。中运卡行APP平台上已经形成多样而活跃的网络货运平台生态，货物、货车、ETC、加油、车险、货车信息流和资金流等新产品打造的新场景，吸引货主、司机用户参与广告主产品创新与品牌的建设与传播。</p>
        </div>
        <div>
            <img v-lazy="'../../static/img/011.jpg'" style="width:23vw;margin-right:1vw" alt="">
            <img v-lazy="'../../static/img/012.jpg'" style="width:23vw;margin-right:1vw" alt="">
            <img v-lazy="'../../static/img/013.jpg'" style="width:23vw;margin-right:1vw" alt="">
        </div>
        <h2 class="h2bottom" style="margin-top:5vw">终于卡行APP广告规范&广告示例</h2>
        <p style="font-size:1.5vw;font-weight: 400;color: #666666;margin-bottom:5vw">—— Advertising demonstration ——</p>
        <img v-lazy="'../../static/img/016.png'" style="margin:0px 12%;width:76%" alt="">
        <h2 class="h2bottom" style="margin-top:5vw">合作流程</h2>
        <p style="font-size:1.5vw;font-weight: 400;color: #666666;margin-bottom:5vw">—— Cooperation process ——</p>
        <div>
            <img v-lazy="'../../static/img/024.png'" style="width:24vw;margin-right:1vw" alt="">
            <img v-lazy="'../../static/img/025.png'" style="width:24vw;margin-right:1vw;cursor: pointer;" alt="">
            <img v-lazy="'../../static/img/026.png'" style="width:24vw;margin-right:3vw" alt="">
        </div>
        <div id="contactUs" class="contactUs">
		<h2>余先生</h2>
		<div>
			<img v-lazy="'../../static/img/phone.png'" style="width:1.9vw;margin-left:1.5%" alt="">
			<div>
				<p>联系电话：</p>
				<p style="font-weight: bold;">TEL: 400-966-2156</p>
			</div>
            <div style="flex:1;display:flex;flex-direction: row;justify-content:flex-end;margin-top:-4vw">
                <img v-lazy="'../../static/img/erwei1.jpg'" style="width:7vw;height:7vw" alt="">
                <img v-lazy="'../../static/img/erwei2.jpg'" style="width:7vw;height:7vw" alt="">
            </div>
		</div>
		<div style="border-bottom: #E1E1E1 0.2vw dashed;">
			<img v-lazy="'../../static/img/email.png'" alt="">
			<div style="margin-bottom:3vw;">
				<p>邮箱：</p>
				<p>alink@shyingsu.cn</p>
			</div>
		</div>
		<p style="margin-left:10%;font-size:2vw;color: #999999;">查看路线</p>
		<div>
			<img v-lazy="'../../static/img/location.png'" style="width:1.7vw;margin-left:1.5%" alt="">
			<div>
				<p>公司地址：</p>
				<p>上海市宝山区城银路555弄6号2幢2楼</p>
			</div>
		</div>
		<img v-lazy="'../../static/img/map.png'" style="width:100%;margin:0px" alt="" @click="clickMethod">
	</div>
    </div>
</template>
<script>
export default {
    mounted () {
       window.scrollTo(0, 0)
    },
	methods: {
		clickMethod () {
			window.open('https://www.amap.com/search?query=上海鹰速物流有限公司', '_blank')
		}
	}
}
</script>
<style lang="less" scoped>
.Index{
  margin-top: 66px;
  text-align:center;
  display:flex;
  justify-content:center;
  flex-direction: column;
}
.divText {
    text-align:left;
    margin:0px 15%;
    margin-bottom: 3vw;
    p {
        font-size: 1vw;
        line-height: 3em;
    }
}
.contactUs {
	text-align:left;
	h2 {
		color:#343434;
		padding-top:50px;
		font-size:2vw;
		margin-left:10%;
	}
	div {
		margin:40px 10%;
		display: flex;
		img {
			margin:0px;
			width:3vw;
			height:2vw;
			margin-right:3vw;
		}
		div {
			margin: 0px;
			display: flex;
			flex-direction: column;
			p {
				font-size: 1vw;
				color: #999;
				margin-bottom: 0.8vw;
			}
		}
	}
	img {
		width:80%;
		margin-bottom:50px;margin-top:30px;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/advertisement.vue